import ValidateContactsModal from "../../components/Contact/ValidateContacts/tableModal";
import { Box } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  modalStyle: {
    padding: "20px",
    maxheight: "95vh!important",
    minWidth: "670px",
    background: "#ffffff",
    marginTop: "10px",
    marginLeft: "10px",
    marginRight: "10px",
    borderRadius: "10px",
    boxShadow: "0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2)",
    "@media (max-width: 740px)": {
      padding: "0px !important",
      marginTop: "65px",
    }
  },
}));

export default function ContactValidate() {

  const classes = useStyles();

  return (
    <Box
      component="div"
      className={classes.modalStyle}
      id="box"
    >
      <ValidateContactsModal />
    </Box>
  );
}
